import React from "react";
import logger from "logger";
import TaskDialog from "TaskDialogCommon/TaskDialog";
import RunButton from "TaskDialogCommon/RunButton";
import TaskCheckBox from "TaskDialogCommon/TaskCheckBox";
import Instruction from "TaskDialogCommon/Instruction";
import TaskInput from "TaskDialogCommon/TaskInput";
import TroopMapSelector from "TaskDialogCommon/TroopMapSelector";
import { StringSelect } from "TaskDialogCommon/StringSelect";
import { getTroopNameFromId } from "Utils/Common";
import { getLastConfigForTask } from "Utils/Common";

const tatstaticconfig = {
  Troop: [
    {
      cname: "City 1",
      cno: "1",
    },
    {
      cname: "City 2",
      cno: "2",
    },
    {
      cname: "City 3",
      cno: "3",
    },
    {
      cname: "City 4",
      cno: "4",
    },
  ],
  Tactical: [
    {
      cname: "Lake-Town",
      cno: "99",
    },
  ],
  Wall: [
    {
      cname: "City 1",
      cno: "1",
    },
    {
      cname: "City 2",
      cno: "2",
    },
    {
      cname: "City 3",
      cno: "3",
    },
    {
      cname: "City 4",
      cno: "4",
    },
    {
      cname: "Lake-Town",
      cno: "99",
    },
  ],
};
const taskname = "tat";

export default class Component extends React.Component {
  constructor(props) {
    super();
    const { accountdetailrow, AccountDetailData } = props;
    this.tattroopconfig = {
      Troop: [],
      Tactical: [],
      Wall: [],
      Dismissable: [],
    };
    for (var key in AccountDetailData.troopdictionary) {
      var troopdef = AccountDetailData.troopdictionary[key];
      if (troopdef.isWall === true) {
        this.tattroopconfig.Wall.push(troopdef);
      } else if (troopdef.isTact === true) {
        this.tattroopconfig.Tactical.push(troopdef);
        this.tattroopconfig.Dismissable.push(troopdef);
      } else {
        this.tattroopconfig.Troop.push(troopdef);
        this.tattroopconfig.Dismissable.push(troopdef);
      }
    }

    const initialState = {
      taskConfig: {
        accountdetail: accountdetailrow,
        selectedtattype: Object.keys(tatstaticconfig)[0],
        selectedcity: null,
        selectedtroop: "",
        dismisstroop: "",
        smaughit: false,
        shperqueue: "1",
        selectedhero: {},
        noOfHits: "2000",
        speedinsecs: "15",
        passcode: "",
        troops: {},
        unboxtroops: false,
      },
      selectedcityforsh: null,
    };
    logger.log(`loading ${taskname} dialog`, props);
    this.loadStoredData(initialState, props);
    logger.log("initialState after load", initialState);
    this.state = initialState;
  }

  componentDidMount = () => {
    this.selectdefaultcity();
  };

  selectdefaultcity = () => {
    this.setState((s, p) => {
      const {
        taskConfig: { selectedtattype },
        taskConfig,
      } = s;
      let selectedcity = null;
      if (selectedtattype && selectedtattype.length > 0) {
        selectedcity = tatstaticconfig[selectedtattype][0];
      }
      return {
        taskConfig: { ...taskConfig, selectedcity },
      };
    }, this.setHeroesForThisCity);
  };

  setHeroesForThisCity = () => {
    const {
      state: {
        taskConfig: { selectedcity },
      },
      props: { AccountDetailData },
    } = this;
    let selectedcityforsh = null;
    if (selectedcity) {
      for (var v in AccountDetailData.heroes) {
        var ele = AccountDetailData.heroes[v];
        if (ele.cityno === selectedcity.cno) {
          selectedcityforsh = ele;
          break;
        }
      }
    }
    this.setState({ selectedcityforsh });
  };

  validate = () => {
    return true;
  };

  loadStoredData = (initialState, props) => {
    const { taskConfig } = initialState;
    const { selectedcityforsh } = initialState;
    try {
      const { AccountDetailData: accountdetail } = props;
      var storeddata = getLastConfigForTask(taskname);
      logger.log("storeddata", storeddata, accountdetail);
      if (storeddata) {
        taskConfig.selectedtattype = storeddata.selectedtattype;
        for (var item in tatstaticconfig[taskConfig.selectedtattype]) {
          var cObj = tatstaticconfig[taskConfig.selectedtattype][item];
          if (storeddata.selectedcity.cno === cObj.cno) {
            taskConfig.selectedcity = cObj;
            break;
          }
        }
        taskConfig.selectedtroop = storeddata.selectedtroop;
        taskConfig.dismisstroop = storeddata.dismisstroop;
        taskConfig.smaughit = storeddata.smaughit;
        taskConfig.shperqueue = storeddata.shperqueue;

        for (var hkey in selectedcityforsh.cityheroes) {
          var heroObj = selectedcityforsh.cityheroes[hkey];
          if (heroObj.heroname === storeddata.selectedhero.heroname) {
            taskConfig.selectedhero = storeddata.selectedhero;
          }
        }

        taskConfig.noOfHits = storeddata.noOfHits;
        taskConfig.speedinsecs = storeddata.speedinsecs;
        taskConfig.passcode = storeddata.passcode;
        taskConfig.troops = { ...storeddata.troops };
        if (storeddata.unboxtroops) {
          taskConfig.unboxtroops = storeddata.unboxtroops;
        }
      }
    } catch (e) {
      logger.log(e);
    }
  };

  setValue = (event, key) => {
    const value = event.target.value;
    this.setState((s, p) => ({
      taskConfig: { ...s.taskConfig, [key]: value },
    }));
  };

  setTaskConfigChanges = (taskConfigChanges, callBack) => {
    this.setState(
      (s, p) => ({
        taskConfig: { ...s.taskConfig, ...taskConfigChanges },
      }),
      callBack
    );
  };

  render = () => {
    const {
      setValue,
      validate,
      setTaskConfigChanges,
      state: { taskConfig, selectedcityforsh },
      props: { AccountDetailData },
    } = this;

    logger.log("this.state", this.state);

    return (
      <TaskDialog heading={"Trainathon"}>
        <StringSelect
          label={"Select Tat Type"}
          param={"selectedtattype"}
          setTaskConfigChanges={(taskConfigChanges) => {
            setTaskConfigChanges(taskConfigChanges);
            this.selectdefaultcity();
          }}
          taskConfig={taskConfig}
          optionObject={tatstaticconfig}
          labelParser={(k, v) => k}
          valueParser={(k, v) => k}
        />
        <StringSelect
          label={"Select City To Train in:"}
          param={"selectedcity"}
          setTaskConfigChanges={(taskConfigChanges) => {
            setTaskConfigChanges(taskConfigChanges, this.setHeroesForThisCity);
          }}
          taskConfig={taskConfig}
          optionObject={tatstaticconfig[taskConfig.selectedtattype]}
          labelParser={(k, v) => v.cname}
          valueParser={(k, v) => v}
        />
        <StringSelect
          label={"Select Troop To Train:"}
          param={"selectedtroop"}
          setTaskConfigChanges={setTaskConfigChanges}
          taskConfig={taskConfig}
          optionObject={this.tattroopconfig[taskConfig.selectedtattype]}
          labelParser={(k, v) => getTroopNameFromId(v.id)}
          valueParser={(k, v) => v.id}
        />
        <StringSelect
          label={"Select Troop To Dismiss:"}
          param={"dismisstroop"}
          setTaskConfigChanges={setTaskConfigChanges}
          taskConfig={taskConfig}
          optionObject={this.tattroopconfig["Dismissable"]}
          labelParser={(k, v) => getTroopNameFromId(v.id)}
          valueParser={(k, v) => v.id}
        />

        <TaskInput
          label={"No of queues to train"}
          value={taskConfig.noOfHits}
          onChange={(event) => setValue(event, "noOfHits")}
        />

        <TaskInput
          label={"Train Speed in secs"}
          value={taskConfig.speedinsecs}
          onChange={(event) => setValue(event, "speedinsecs")}
        />

        {selectedcityforsh && (
          <TaskCheckBox
            label={"Make this a smaug hit tat."}
            param={"smaughit"}
            taskConfig={taskConfig}
            setValue={setValue}
          />
        )}

        {selectedcityforsh && !taskConfig.smaughit && (
          <>
            <Instruction>
              *A Smaug hit tat is a special way of doing tat where before
              training every queue you have a hero set up in your city hit smaug
              a number of times. The immediate resources gained in the city by
              hitting smaug are then instantly used for training the next queue.
              This has the advantage of not needing rss to be already stored in
              city as they are farmed as needed. Please make sure the hero u are
              using is strong and that you have enough stamina left for the day
              to keep hitting smaug :) <br /> *You can only SELECT a hero from
              same city as the one you doing tat in since the resources from
              farming has to go in that city..
            </Instruction>
          </>
        )}
        {this.state.taskConfig.smaughit && selectedcityforsh && (
          <>
            <StringSelect
              label={"Select Smaug Hit Hero"}
              param={"selectedhero"}
              setTaskConfigChanges={setTaskConfigChanges}
              taskConfig={taskConfig}
              optionObject={selectedcityforsh.cityheroes}
              labelParser={(k, v) => v.heroname}
              valueParser={(k, v) => v}
            />
            <TaskInput
              label={"No of Smaug hits per queue"}
              value={taskConfig.shperqueue}
              onChange={(event) => setValue(event, "shperqueue")}
            />
            <Instruction>
              *This is no of times smaug is hit before each queue. By default 1
              should work. However if food drain in your city is too fast
              because of lots of troops, you might need to hit smaugh 2-3 times
              to collect enough food before trying to train a queue.
            </Instruction>
            <TroopMapSelector
              AccountDetailData={AccountDetailData}
              taskConfig={taskConfig}
              setValue={setValue}
              label={"Add Troops To Send For Smaug hit"}
              param={"troops"}
            />
          </>
        )}
        {taskConfig.selectedtattype === "Wall" && (
          <>
            <TaskInput
              label={"Wall remover passcode(Optional)"}
              value={taskConfig.passcode}
              onChange={(event) => setValue(event, "passcode")}
            />
          </>
        )}
        <TaskCheckBox
          label={"Auto Unbox Troops for dismissing, if/when needed."}
          param={"unboxtroops"}
          taskConfig={taskConfig}
          setValue={setValue}
        />
        <RunButton
          taskname={taskname}
          taskConfig={taskConfig}
          label={"Run Tat"}
          validate={validate}
        />
      </TaskDialog>
    );
  };
}
